import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import VideoCallIcon from "@mui/icons-material/VideoCall";

export default function History() {
  const { getHistoryOfUser } = useContext(AuthContext);
  const [meetings, setMeetings] = useState([]);
  const routeTo = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      const history = await getHistoryOfUser();
      setMeetings(history);
    };
    fetchHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  return (
    <div
      className="historyPage"
      style={{
        position: "relative",
        background: "radial-gradient(circle at top left, #6366f1, #0b0d17 60%)",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <div className="historyHeader">
        <IconButton onClick={() => routeTo("/home")}>
          <HomeIcon />
        </IconButton>
        <h2>Meeting History</h2>
      </div>

      {/* CONTENT */}
      <div className="historyGrid">
        {meetings.length > 0 ? (
          meetings.map((e, i) => (
            <Card key={i} className="historyCard">
              <CardContent>
                <Typography variant="h6">
                  <VideoCallIcon sx={{ mr: 1 }} />
                  {e.meetingCode}
                </Typography>

                <Typography color="text.secondary">
                  {formatDate(e.date)}
                </Typography>

                <Box sx={{ mt: 2 }}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => routeTo(`/${e.meetingCode}`)}
                  >
                    Rejoin
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))
        ) : (
          <p className="emptyHistory">
            No meetings yet. Start your first call 🚀
          </p>
        )}
      </div>
    </div>
  );
}
